import { render, staticRenderFns } from "./v-supply-select-list.vue?vue&type=template&id=1a50d320&scoped=true&"
import script from "./v-supply-select-list.vue?vue&type=script&lang=js&"
export * from "./v-supply-select-list.vue?vue&type=script&lang=js&"
import style0 from "./v-supply-select-list.vue?vue&type=style&index=0&id=1a50d320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a50d320",
  null
  
)

export default component.exports